export default (descriptorFilter, productsById, descriptorsById, descriptorsData, productScenarioDescriptors, scenariosById) => {

  const filteredDescriptors = descriptorsData.filter(v => v.id_tipo === descriptorFilter);
  const filteredDescriptorsIds = filteredDescriptors.map(fD => fD.id);
  const filteredSD = productScenarioDescriptors.filter(fSD => filteredDescriptorsIds.includes(fSD.id_descritor));

  const mergedProductDescriptors = [];
  const descriptorRepetitions = [];
  filteredSD.forEach(fSD => {
    if (!descriptorRepetitions.includes(fSD.id_descritor)) {
      const scenariodescriptorGrouped = filteredSD.filter(item => item.id_descritor === fSD.id_descritor);
      const mergedDescriptor = {
        id: fSD.id_descritor,
        descriptor_code: descriptorsById[fSD.id_descritor].codigo,
        descriptor_description: descriptorsById[fSD.id_descritor].descricao,
        productsInfo: []
      };

      const repeatedProducts = [];
      scenariodescriptorGrouped.forEach(sdg => {
        const product = productsById[scenariosById[sdg.id_cenario].id_produto];
        if (!repeatedProducts.includes(product.id)) {
          mergedDescriptor.productsInfo.push({
            code: product.codigo_produto,
            name: product.produto_nome
          });
          repeatedProducts.push(product.id);
        }
      });

      descriptorRepetitions.push(fSD.id_descritor);
      mergedProductDescriptors.push(mergedDescriptor);
    }
  });

  return mergedProductDescriptors;
};